import { computed } from "vue";
import { getClientConfig } from "./queries";
import { useAxureCloudConfig } from "./useAxureCloudConfig";

/**
 * Sub-instance check for code that runs outside of an injection context
 * (event handlers, plain modules), where vue-query hooks are unavailable.
 * Reads the server-embedded config, which is also the initial data of the config query.
 */
export function isSubInstance() {
  return getClientConfig()?.IsSubInstance ?? false;
}

export function useIsSubInstance() {
  const config = useAxureCloudConfig();
  return computed(() => config.value?.IsSubInstance ?? false);
}

export function useSubInstanceId() {
  const config = useAxureCloudConfig();
  return computed(() => config.value?.SubInstanceId ?? "");
}
